import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './App.css'; // Assuming your CSS file

const CoverImageFive = () => {

    return (

    <div className="cover-image-background">
                <div className="image1-text reveal">
                    <h1>Cocoloco Packages</h1>
                    <p>
                         At Cocoloca Garden, we present you with exceptional packages designed for a memorable day spent with your loved ones.
                    </p>
                </div>
            </div>

    );
};

export default CoverImageFive;
